import { Alert, Snackbar } from "@mui/material";
import { FC } from "react";
import { theme } from "../config/theme";
import { ICustomSnackbarProps } from "../interfaces/snackbar";

const CustomSnackbar: FC<ICustomSnackbarProps> = (props) => {
  const { onClose, open, type, message } = props;
  return (
    <Snackbar
      open={open}
      autoHideDuration={5000}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        severity={type}
        variant="filled"
        sx={{ width: "100%", color: theme.palette.common.white }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default CustomSnackbar;
